"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosAdvertiserUpdateInputSchema = exports.APosAdvertiserCreateInputSchema = exports.APosAdvertiserSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosAdvertiserSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    advertiserId: id_schema_1.EntityIdSchema,
    companyName: zod_1.z.string().min(1).max(200),
    contactName: zod_1.z.string().max(100).optional(),
    email: zod_1.z.string().email().optional(),
    phone: zod_1.z.string().max(30).optional(),
    website: zod_1.z.string().url().optional(),
    isActive: zod_1.z.boolean().default(true),
    totalAds: zod_1.z.number().int().nonnegative().default(0),
    totalSpent: zod_1.z.number().nonnegative().default(0),
    balance: zod_1.z.number().default(0),
    notes: zod_1.z.string().max(2000).optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosAdvertiserCreateInputSchema = zod_1.z.object({
    companyName: zod_1.z.string().min(1).max(200),
    contactName: zod_1.z.string().max(100).optional(),
    email: zod_1.z.string().email().optional(),
    phone: zod_1.z.string().max(30).optional(),
    website: zod_1.z.string().url().optional(),
    notes: zod_1.z.string().max(2000).optional(),
});
exports.APosAdvertiserUpdateInputSchema = exports.APosAdvertiserCreateInputSchema.partial().extend({
    isActive: zod_1.z.boolean().optional(),
});
//# sourceMappingURL=advertiser.schema.js.map